import React from 'react';
import Check from '../../../assets/check.svg';
import './styles.css';
export var Feature = function (_a) {
    var title = _a.title, children = _a.children;
    return (React.createElement("div", { className: 'featureContainer' },
        React.createElement(Check, null),
        React.createElement(FeatureDetails, { title: title, children: children })));
};
var FeatureDetails = function (_a) {
    var title = _a.title, children = _a.children;
    return (React.createElement("div", { className: 'feature' },
        React.createElement("h3", null, title),
        children));
};
